import { useEffect, useState } from 'react';

interface UseResponsiveReturn {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
  orientation: 'portrait' | 'landscape';
  touchDevice: boolean;
  prefersReducedMotion: boolean;
}

export const useResponsive = (): UseResponsiveReturn => {
  const [screenInfo, setScreenInfo] = useState<UseResponsiveReturn>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    screenWidth: 1024,
    orientation: 'landscape',
    touchDevice: false,
    prefersReducedMotion: false
  });

  useEffect(() => {
    const updateScreenInfo = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      
      // Breakpoints
      const isMobile = width < 768;
      const isTablet = width >= 768 && width < 1024;
      const isDesktop = width >= 1024;
      
      // Orientation
      const orientation = width > height ? 'landscape' : 'portrait';
      
      // Touch device detection
      const touchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      
      // Reduced motion preference
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      setScreenInfo({
        isMobile,
        isTablet,
        isDesktop,
        screenWidth: width,
        orientation,
        touchDevice,
        prefersReducedMotion
      });
    };

    // Initial check
    updateScreenInfo();

    // Listen for resize and orientation changes
    window.addEventListener('resize', updateScreenInfo);
    window.addEventListener('orientationchange', updateScreenInfo);
    
    // Listen for reduced motion preference changes
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    mediaQuery.addEventListener('change', updateScreenInfo);

    return () => {
      window.removeEventListener('resize', updateScreenInfo);
      window.removeEventListener('orientationchange', updateScreenInfo);
      mediaQuery.removeEventListener('change', updateScreenInfo);
    };
  }, []);

  return screenInfo;
};